import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ProposalModel, ErrorInformation } from "../models/ProposalModel";

import { apiDelete, apiGet, apiPost, apiPut } from "src/utils/axios";

import { errorHandler } from "src/utils/errorHandler";

import {
  getProposalTemplateBank,
  getProposalTemplateBankDetail,
  putProposalDetails,
  getPastProposalsList,
  getVendorMasterTemplateUrl
} from "src/utils/pathConst";
import { RfpParams, TemplateListModel } from "src/models/rfp";

type ProposalServiceState = {
  loading: boolean;
  error: ErrorInformation;
  proposalData: ProposalModel;
  successPutProposal: string;
};

const initialState: ProposalServiceState = {
  loading: true,
  error: null,
  proposalData: null,
  successPutProposal: "",
};

export const putProposalData = createAsyncThunk<
  string, //output
  { payload: ProposalModel; params: any },
  { rejectValue: ErrorInformation }
>(
  "proposal/putProposalData",
  async ({ payload, params }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`${putProposalDetails}/${params}`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getProposalTemplateBankList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getProposalTemplateBankList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getProposalTemplateBank}/list?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getPastProposalList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getPastProposalList",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getPastProposalsList}?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);


export const previewProposalTemplateBank = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/previewProposalTemplateBank",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getProposalTemplateBankDetail}/get_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getMasterProposalDataById = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getMasterProposalDataById",
  async (params: RfpParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getVendorMasterTemplateUrl}/get_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  reducers: {
    
  },
  extraReducers: {
    [putProposalData.pending.type]: (state) => {
      state.loading = true;
    },
    [putProposalData.fulfilled.type]: (
      state,
      action: PayloadAction<string>
    ) => {
      state.successPutProposal = action.payload;
      state.loading = false;
      state.error = null;
    },
    [putProposalData.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getProposalTemplateBankList.pending.type]: (state) => {
      state.loading = true;
    },
    [getProposalTemplateBankList.fulfilled.type]: (
      state,
      action: PayloadAction<string>
    ) => {
      state.successPutProposal = action.payload;
      state.loading = false;
      state.error = null;
    },
    [getProposalTemplateBankList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// export default proposalSlice
